export default __webpack_public_path__ + "static/media/michael_levitt.bcb183d2.jpg";